<template>
  <section class="comments">
    <div class="content">
      <h1 class="title">{{ translations[lang].title }}</h1>
      <div class="swiper-overlay">
        <button class="swiper-nav swiper-nav-next" @click="swiper.slideNext()"></button>
        <button class="swiper-nav swiper-nav-prev" @click="swiper.slidePrev()"></button>
        <swiper :loop="true" :modules="modules" :slides-per-view="1" :space-between="45" :speed="750" @swiper="onSwiper">
          <swiper-slide v-for="(item, index) in slides" :key="index">
            <FeedbackSlide :slide="item" :index="index" />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay } from 'swiper/modules';
import FeedbackSlide from '@/Components/En/Common/FeedbackSlide.vue';

import 'swiper/swiper-bundle.css';

export default {
  name: 'Gallery',
  components: {
    Swiper,
    SwiperSlide,
    FeedbackSlide,
  },
  props: {
    close: {
      default: () => null,
      type: Function,
    },
    openQuestionForm: {
      default: () => null,
      type: Function,
    },
    lang: {
      type: String,
      default: 'en',
    },
  },
  setup() {
    return {
      modules: [Autoplay],
    };
  },
  data() {
    return {
      swiper: null,
      slides: [
        { subtitle: 'The first feedback', img: 'gallery-slide-1' },
        { subtitle: 'The second feedback', img: 'gallery-slide-2' },
        { subtitle: 'The third feedback', img: 'gallery-slide-3' },
        { subtitle: 'The fourth feedback', img: 'gallery-slide-4' },
      ],
      translations: {
        en: {
          title: 'Users’ feedback',
        },
        ru: {
          title: '',
        },
      },
    };
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },
  },
};
</script>
